export const addDecimals = (num) => {
    return (Math.round(num * 100) / 100).toFixed(2);
}

export const updateCart = (state) => {
    // Calculate items price
    state.itemsPrice = addDecimals(state.cartItems.reduce((acc, item) => acc + item.price * item.qty, 0));

    // Calculate shipping price - free on orders of £50 or more, else £3.99
    // (keep in sync with backend/utils/calcPrices.js)
    state.shippingPrice = addDecimals(Number(state.itemsPrice) >= 50 ? 0 : 3.99);

    // itemsPrice is VAT-inclusive (UK 20%), so extract rather than add the VAT portion: price / 6
    state.taxPrice = addDecimals(Number((state.itemsPrice / 6).toFixed(2)));

    // VAT is already included in itemsPrice, so don't add it again here
    state.totalPrice = (
        Number(state.itemsPrice) +
        Number(state.shippingPrice)
    ).toFixed(2);

    // Strip guestEmail before persisting — it's session state only,
    // should not survive a browser close/reopen
    const { guestEmail, ...persistableState } = state;
    localStorage.setItem('cart', JSON.stringify(persistableState));

    return state;
}